<div>
    <p style="margin: 0; text-align: center;">Batch cloning of projects is in-progress.</p>
</div>